import React, { useEffect, useRef, useState } from "react";
import CheckPicker from "rsuite/CheckPicker";
import { apiRequest, predefinedRanges, uistyles } from "../../utils/utils";
import { BsSearch } from "react-icons/bs";
import Dropdown from "rsuite/Dropdown";
import Button from "rsuite/Button";
import Loader from "rsuite/Loader";
import DateRangePicker from "rsuite/DateRangePicker";
import TagPickerImageValueRenderer from "../crm/TagPickerImageValueRenderer";
import Avatar from "rsuite/esm/Avatar";
import TagPickerValueRenderer from "../crm/TagPickerValueRenderer";
import SelectPicker from "rsuite/esm/SelectPicker";
import { BiX } from "react-icons/bi";
import { FaRegEyeSlash } from "react-icons/fa";
import {
  clearLocalStorage,
  getFromLocalStorage,
  storeToLocalStorage,
} from "../../utils/storeLocalStorage";
import CheckboxGroup from "rsuite/esm/CheckboxGroup";
import Checkbox from "rsuite/esm/Checkbox";
import { getCookie } from "../crm/customer/Utility";
import { decrypt } from "../../actions/common";
import { MdSearch } from "react-icons/md";
import { useLocation } from "react-router-dom";

// top Filter in account listing parent component

const ListingTopFilter = ({
  aggridData,
  handleSelectChange,
  showCustomerMap,
  syncFilterWithAggrid,
  columnsUpdateAgGrid,
  getUserData,
  ...rest
}) => {
  const location = useLocation();
  const [state, setState] = useState({
    customerTypeData: [],
    packageData: [],
    showFilter: false,
    isOpen: false,
    openWithHeader: false,
    isDateFilter: false,
    filterValue: {},
    advanceFilter: false,
    moreButton: true,
    applicationData: [],
    sourceData: [],
    filterKeyLists: [],
    countriesData: [],
    accountManagerData: [],
    salesManagerData: [],
    tseOwnerData: [],
    cancelReasonData: [],
    isLoading: {},
    productData: [],
    filters: {},
    hiddenColumns: [],
    showHiddenColumns: false,
    search: "",
    columnsData: [],
    columnsValueSearch: { key: "", value: "" },
    dataTypeAttr: [],
  });
  let user_uuid = getCookie("muvi_useruuid");
  let searchRef = useRef(null);
  const isFirstRender = useRef(true);
  var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
  var localdata = has_local_data
    ? decrypt(localStorage.getItem("encdata"), 0)
    : "";

  const hiddenColumnShows = useRef(null);
  const columnRefsvalue = useRef(null);

  const filterOnchangeData = (val, key = null, type = null) => {
    

    let filtercopy = { ...state.filters };

    if (type === "crm_product") {
      if (key === "created_date") {
        let newdate;
        if (val) {
          newdate = val.map((date) => {
            const newdate = new Date(date);
            newdate.setDate(newdate.getDate() + 1);
            return newdate.toISOString().split("T")[0];
          });
        } else {
          newdate = [];
        }

        filtercopy = {
          ...filtercopy,
          crm_product: { ...filtercopy.crm_product, range: { [key]: newdate } },
        };
      } else {
        filtercopy = {
          ...filtercopy,
          crm_product: { ...filtercopy.crm_product, [key]: val },
        };
      }
    }

    if (type === "crm_user") {
      filtercopy = {
        ...filtercopy,
        crm_user: { ...filtercopy.crm_user, [key]: val },
      };
    }

    syncFilterWithAggrid(filtercopy);

    setState((state) => {
      return {
        ...state,
        filters: filtercopy,
      };
    });

    // set filter in local storage

    const filtersString = JSON.stringify(filtercopy);
    storeToLocalStorage(filtersString, "crm_filter");
  };
  useEffect(() => {
    setState(state => {
      return {
        ...state,
        filters: {...aggridData.filter, ...state.filters}
      }
    })
},[aggridData])

  const handleApplyTime = (key = null) => {};

  const getTattleColumnSearch = async () => {
    const requestBody = {
      app_token: process.env.REACT_APP_tattle_token,
      attribute_set_key: "crm",
      // user_uuid: user_uuid ? user_uuid : localdata.user_uuid,
      // attribute_status: true,
    };
    const responseData = await apiRequest(
      `${process.env.REACT_APP_tattle_api}/tattle/attributes`,
      "POST",
      requestBody
    );

    if (responseData.code === 200) {
      const { data } = responseData;

      if (data.length) {
        const checkdatetype = data
        .filter((item) => item.attribute_type === "date")
        .map((it) => it.field);
        const columsndata = data.map((item) => ({
          label: item.headerName,
          value: item.field,
        }));
        setState((state) => {
          return {
            ...state,
            columnsData: columsndata,
            dataTypeAttr: checkdatetype || [],
          };
        });
      }
    }
  };

  const getTattleColumnList = async () => {
    const requestBody = {
      app_token: process.env.REACT_APP_tattle_token,
      attribute_set_key: "crm",
      user_uuid: user_uuid ? user_uuid : localdata.user_uuid,
      // attribute_status: true,
    };
    const responseData = await apiRequest(
      `${process.env.REACT_APP_tattle_api}/tattle/list`,
      "POST",
      requestBody
    );
    

    if (responseData.code === 200) {
      const { data } = responseData;
      
      const hiddenColumns = data.hidden_columns || [];

      setState((state) => {
        return {
          ...state,
          hiddenColumns: hiddenColumns,
        };
      });
    }
  };

  const getCustomerType = async (key) => {
    setState((state) => {
      return {
        ...state,
        isLoading: { [key]: true },
      };
    });
    const response = await apiRequest(
      `${process.env.REACT_APP_tattle_api}/get-customerType`
    );

    
    if (response) {
      const resdata = Object.entries(response).map(([key, value]) => {
        return { label: value.customer_type, value: key };
      });
      

      setState((state) => {
        return {
          ...state,
          customerTypeData: resdata,
          isLoading: { [key]: false },
        };
      });
    }
  };

  const getPackage = async (key) => {
    setState((state) => {
      return {
        ...state,
        isLoading: { [key]: true },
      };
    });
    const response = await apiRequest(
      `${process.env.REACT_APP_CRM}/crm/package-list`
    );
    
    if (response.code === 200) {
      const { data } = response;

      const transdata = data.map((ite) => {
        return { label: ite.value, value: ite.value };
      });

      setState((state) => {
        return {
          ...state,
          packageData: transdata,
          isLoading: { [key]: false },
        };
      });
    }
  };

  const getApplication = async (key) => {
    setState((state) => {
      return {
        ...state,
        isLoading: { [key]: true },
      };
    });
    const responseData = await apiRequest(
      `${process.env.REACT_APP_CRM}/crm/application-list`
    );
    
    if (responseData.code === 200) {
      const { data } = responseData;
      const redata = data.map((ite) => ({ label: ite.name, value: ite.name }));
      setState((state) => {
        return {
          ...state,
          applicationData: redata,
          isLoading: { [key]: false },
        };
      });
    }
  };

  const getSource = async (key) => {
    setState((state) => {
      return {
        ...state,
        isLoading: { [key]: true },
      };
    });
    const responseData = await apiRequest(
      `${process.env.REACT_APP_CRM}/crm/source-list`
    );
    if (responseData.code === 200) {
      const { data } = responseData;

      const redata = data.map((it) => ({ label: it.name, value: it.value }));
      setState((state) => {
        return {
          ...state,
          sourceData: redata,
          isLoading: { [key]: false },
        };
      });
    }
  };

  const getCountries = async (key) => {
    setState((state) => {
      return {
        ...state,
        isLoading: { [key]: true },
      };
    });
    const responsedata = await apiRequest(
      `${process.env.REACT_APP_CRM}/crm/country-list`
    );

    if (responsedata.code === 200) {
      const { data } = responsedata;
      const redata = data.map((ite) => ({
        label: ite.nicename,
        value: ite.iso,
      }));

      setState((state) => {
        return {
          ...state,
          countriesData: redata,
          isLoading: { [key]: false },
        };
      });
    }
  };

  const showHiddenAttribute = async (ev, attr) => {
    ev.preventDefault();
    
    const { field } = attr;
    const data = {
      status_type: "show",
      attributes: [field],
      app_token: process.env.REACT_APP_tattle_token,
      attribute_set_key: "crm",
      user_uuid: user_uuid ? user_uuid : localdata.user_uuid,
    };
    const responseData = await apiRequest(
      `${process.env.REACT_APP_tattle_api}/attribute/hide`,
      "POST",
      data
    );

    if (responseData.code === 200) {
      const copyColumns = [...state.hiddenColumns];

      const newcopycolumns = copyColumns.filter((item) => item.field !== field);
      setState((state) => {
        return {
          ...state,
          hiddenColumns: newcopycolumns,
        };
      });
      columnsUpdateAgGrid();
    }
  };

  const getCancelReason = async (key) => {
    setState((state) => {
      return {
        ...state,
        isLoading: { [key]: true },
      };
    });
    const responseData = await apiRequest(
      `${process.env.REACT_APP_CRM}/crm/cancel-reason-list`
    );
    if (responseData.code === 200) {
      const { data } = responseData;

      const redata = data.map((it) => ({ label: it.name, value: it.value }));

      setState((state) => {
        return {
          ...state,
          cancelReasonData: redata,
          isLoading: { [key]: false },
        };
      });
    }
  };
  const searchValueHandler = (evt) => {
    const { value } = evt.target;
    let filtercopy = { ...state.filters };

    if (
      state.columnsValueSearch.key &&
      state.filterKeyLists.includes(state.columnsValueSearch.key)
    ) {
      filtercopy = {
        ...filtercopy,
        crm_user: {
          ...filtercopy.crm_user,
          [state.columnsValueSearch.key]: value,
        },
      };
    } else {
      filtercopy = {
        ...filtercopy,
        crm_product: {
          ...filtercopy.crm_user,
          [state.columnsValueSearch.key]: value,
        },
      };
    }
  
    setState((state) => {
      return {
        ...state,
        columnsValueSearch: { ...state.columnsValueSearch, value: value },
      };
    });

    if (columnRefsvalue.current) {
      clearTimeout(columnRefsvalue.current);
    }

    columnRefsvalue.current = setTimeout(() => {
      syncFilterWithAggrid(filtercopy);
    }, 1000);
  };

  const handleChangeDateSearch = (evt) => {
    let filtercopy = { ...state.filters };
    if (evt) {
      const dateformat = evt.map(
        (it) => new Date(it).toISOString().split("T")[0]
      );
      

      if (
        state.columnsValueSearch.key &&
        state.filterKeyLists.includes(state.columnsValueSearch.key)
      ) {
        filtercopy = {
          ...filtercopy,
          crm_user: {
            ...filtercopy.crm_user,
            [state.columnsValueSearch.key]: dateformat,
          },
        };
      } else {
        filtercopy = {
          ...filtercopy,
          crm_product: {
            ...filtercopy.crm_user,
            [state.columnsValueSearch.key]: dateformat,
          },
        };
      }
      setState((state) => {
        return {
          ...state,
          columnsValueSearch: {
            ...state.columnsValueSearch,
            value: dateformat,
          },
        };
      });
    }else {
      filtercopy = {
        ...filtercopy,
        crm_product: {
          ...filtercopy.crm_user,
          [state.columnsValueSearch.key]: "",
        },
      };
    }
   

    syncFilterWithAggrid(filtercopy);
  };

  const searchColumnHandler = (evt) => {
    if (!evt) {
      setState((state) => {
        return {
          ...state,
          columnsValueSearch: { value: "", key: "" },
        };
      });
    } else {
      

      if (state.dataTypeAttr.includes(evt)) {
        setState((state) => {
          return {
            ...state,
            isDateFilter: true,
          };
        });
      }
      setState((state) => {
        return {
          ...state,
          columnsValueSearch: { ...state.columnsValueSearch, key: evt },
        };
      });
    }
  };

  useEffect(() => {
    getCustomerType();
    getPackage();
    getCrmFilterKeys();
    // getCustomerType();
    // getApplication();
    // getAccountManager();
    // getSalesManager();
    // getTseOwnerManager();
    // getTattleColumnList();

    let filterdata = getFromLocalStorage("crm_filter");
    
    if (filterdata) {
      filterdata = JSON.parse(filterdata);

      setState((state) => {
        return {
          ...state,
          filters: filterdata,
        };
      });
    }

    document.addEventListener("mousedown", handleClickOutSide);

    return () => {
      document.removeEventListener("mousedown", handleClickOutSide);
    };
  }, []);

  useEffect(() => {
    setState(state => {
      return {
        ...state,
        accountManagerData: rest.accountManager,
        salesManagerData: rest.salesManager,
        tseOwnerData: rest.tseOwner,
        productData: rest.productData,
      };
    });
  }, [rest.accountManager, rest.salesManager, rest.tseOwner, rest.productData]);

  const handleClickOutSide = (evt) => {
    if (
      hiddenColumnShows.current &&
      !hiddenColumnShows.current.contains(evt.target)
    ) {
      setState((state) => {
        return {
          ...state,
          showHiddenColumns: false,
        };
      });
    }
  };

  const getCrmFilterKeys = async () => {
    const responseData = await apiRequest(
      `${process.env.REACT_APP_CRM}/crm/user-filter-list`
    );
    if (responseData.code == 200) {
      
      let crmUserFilterArr = responseData.data.map((item) => item.user_fields);
      setState((state) => {
        return {
          ...state,
          filterKeyLists: crmUserFilterArr,
        };
      });
    } else {
      setState((state) => {
        return {
          ...state,
          filterKeyLists: [
            "name",
            "email",
            "company_name",
            "source",
            "phone_number",
            "domain_name",
            "lead_source",
            "country_code",
          ],
        };
      });
    }
  };

  const getTheHiddenColumns = () => {
    const allColumns = [...state.hiddenColumns];
    let columns;
    if (state.searchAttributeColumns) {
      columns = state.hiddenColumns.filter((item) =>
        item.field
          .toLowerCase()
          .includes(state.searchAttributeColumns.toLowerCase())
      );
    } else {
      columns = allColumns;
    }
    return columns.map((ite) => (
      <div className="columns_field_hidden">
        <input
          type="checkbox"
          name=""
          id=""
          className="form-check-input"
          onClick={(evt) => showHiddenAttribute(evt, ite)}
        />{" "}
        {ite.headerName}
      </div>
    ));
  };

  const resetSearchFilter = () => {

    let filtercopy = { ...state.filters };
    syncFilterWithAggrid(filtercopy);
    setState(state => {
      return {
        ...state,
        columnsValueSearch: { ...state.columnsValueSearch, value: "" },
      };
    });
  };
  const searchAttributeHandler = (evt) => {
    const { name, value } = evt.target;

    setState((state) => {
      return {
        ...state,
        searchAttributeColumns: value,
      };
    });
  };

  const handleInputChange = (evt) => {
    const { name, value } = evt.target;
    setState((state) => {
      return {
        ...state,
        search: value,
      };
    });
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // Mark as mounted
      return; // Stop execution on the first render
    }

    if (searchRef.current) {
      clearTimeout(searchRef.current);
    }

    searchRef.current = setTimeout(() => {
      rest.globalSearch(state.search)
    }, 1000);
  }, [state.search]);

  const showAdvFilter = () => {
    setState((state) => {
      return {
        ...state,
        showFilter: !state.showFilter,
      };
    });
  };

  const handleToggleDropdown = () => {
    setState((state) => {
      return {
        ...state,
        showHiddenColumns: !state.showHiddenColumns,
      };
    });
    getTattleColumnList();
  };

  const resetHandler = () => {
    setState((state) => {
      return {
        ...state,
        filters: {},
        search:""
      };
    });
    clearLocalStorage("crm_filter");
    syncFilterWithAggrid({});
  };

  const handleMoreFilter = () => {
    setState((state) => {
      return {
        ...state,
        moreButton: false,
        advanceFilter: !state.advanceFilter,
      };
    });
  };

  const handleLessFilter = () => {
    setState((state) => {
      return {
        ...state,
        advanceFilter: false,
        moreButton: true,
      };
    });
  };

  return (
    <React.Fragment>
      <div className="row mt-5">
        <div className="col-md-6">
          <div class="row" style={{ margin: "1rem .5rem" }}>
            <div class="col-md-4 col-lg-4">
              <div class="input-box">
                <CheckPicker
                  data={
                    Array.isArray(state.productData) ? state.productData : []
                  }
                  value={
                    state.filters && state.filters && state.filters.crm_product
                    ? state.filters.crm_product.product_key || []
                      : []
                  }
                  onChange={(val) =>
                    filterOnchangeData(val, "product_key", "crm_product")
                  }
                  style={{
                    width: "100%",
                    zIndex: 1050,
                  }}
                  block={true}
                  placeholder="Select Product"
                  loading={
                    state.isLoading &&
                    state.isLoading.product &&
                    state.isLoading.product
                  }
                />
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="input-box">
                <CheckPicker
                  data={state.customerTypeData}
                  value={
                    state.filters && state.filters && state.filters.crm_product
                      ? state.filters.crm_product.customer_type  || []
                      : []
                  }
                  onChange={(val) =>
                    filterOnchangeData(val, "customer_type", "crm_product")
                  }
                  style={{
                    width: "100%",
                    zIndex: 1050,
                  }}
                  block={true}
                  placeholder="Select Customer Type"
                  onOpen={() => getCustomerType("customerType")}
                  loading={
                    state.isLoading &&
                    state.isLoading.customerType &&
                    state.isLoading.customerType
                  }
                />
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="input-box">
                <CheckPicker
                  data={state.packageData}
                  value={
                    state.filters && state.filters && state.filters.crm_product
                      ? state.filters.crm_product.package || []
                      : []
                  }
                  onChange={(val) =>
                    filterOnchangeData(val, "package", "crm_product")
                  }
                  style={{
                    width: "100%",
                    zIndex: 1050,
                  }}
                  block={true}
                  placeholder="Select Package"
                  onOpen={() => getPackage("packageData")}
                  loading={
                    state.isLoading &&
                    state.isLoading.packageData &&
                    state.isLoading.packageData
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div
            className="d-flex"
            style={{ marginTop: "10px", marginRight: "1rem" }}
          >
            <div className="lct-form-group" style={{ height: "37px" }}>
              <button
                type="submit"
                style={{
                  background: "#fff",
                  padding: "8px 3px 8px 11px",
                }}
              >
                <BsSearch />
              </button>
              <input
                placeholder="Search"
                type="text"
                class="form-control input-f"
                name="search"
                id="search"
                autoComplete="off"
                onChange={handleInputChange}
                value={state.search}
                style={{
                  padding: " 0 0 0 5px",
                  height: "35px",
                  borderRadius: "6px",
                }}
              />
            </div>
            <div
              id="toggle-btnf"
              style={{ height: "37px" }}
              class={"toogle-btn" + (state.showFilter ? " collapse-state" : "")}
              onClick={() => showAdvFilter("adv_filter")}
            >
              <svg
                width="20"
                height="17"
                viewBox="0 0 20 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.83333 12.5H11.1667V11.3571H7.83333V12.5ZM4.5 9.07143H14.5V7.92857H4.5V9.07143ZM2 4.5V5.64286H17V4.5H2Z"
                  fill="#303049"
                ></path>
              </svg>
            </div>

            <div
              class="toogle-btn hidden_columns_list_parent"
              style={{ height: "37px", padding: "7px 4px" }}
              ref={hiddenColumnShows}
            >
              <Button
                onClick={() => handleToggleDropdown()}
                appearance="default"
                style={{ background: "#fff" }}
              >
                <FaRegEyeSlash size={18} />
              </Button>
              {state.showHiddenColumns ? (
                <div className="hidden_columns_list">
                  <div className="mb-3">
                    <div className="search_attribute_class">
                      <input
                        type="text"
                        name=""
                        placeholder="Search..."
                        className="form-control"
                        id=""
                        onChange={searchAttributeHandler}
                      />
                      <span className="search_icon">
                        <MdSearch size={20} color="#555" />
                      </span>
                    </div>
                  </div>

                  

                  {getTheHiddenColumns()}
                </div>
              ) : (
                ""
              )}
            </div>

            <div
              class="toogle-btn"
              onClick={resetHandler}
              style={{ height: "37px" }}
            >
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.666748 2.66666V6.66666H4.66675"
                    stroke="#202223"
                    stroke-opacity="0.5"
                    stroke-width="1.33"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M2.34008 10C2.77234 11.2269 3.59164 12.2801 4.67452 13.0009C5.7574 13.7217 7.0452 14.0711 8.34389 13.9963C9.64258 13.9216 10.8818 13.4268 11.8748 12.5865C12.8679 11.7462 13.5609 10.606 13.8496 9.33758C14.1382 8.06917 14.0068 6.74131 13.4752 5.55407C12.9435 4.36684 12.0404 3.38454 10.902 2.75518C9.76351 2.12583 8.45135 1.88352 7.1632 2.06475C5.87505 2.24599 4.68069 2.84095 3.76008 3.76001L0.666748 6.66667"
                    stroke="#202223"
                    stroke-opacity="0.5"
                    stroke-width="1.33"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </span>
            </div>
            <div
              class="toogle-btn"
              onClick={() => showCustomerMap()}
              style={{ height: "37px" }}
            >
              <span>
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        id="adv_filter"
        className={`adv_filter filter-wrap ${state.showFilter ? "show" : ""} `}
      >
        <div className="containerfull">
          <div className="row">
            <div className="col-md-3 col-lg-3">
              <div className="input-box">
                <label className="input-label">Created Date</label>
                
                <DateRangePicker
                  showOneCalendar
                  ranges={predefinedRanges}
                  onOk={handleApplyTime("created_date")}
                  // onClean={handleCleanDate("created_date")}
                  onChange={(val) =>
                    filterOnchangeData(val, "created_date", "crm_product")
                  }
                  oneTap={false}
                  value={
                    state.filters &&
                    state.filters.crm_product &&
                    state.filters.crm_product.range &&
                    state.filters.crm_product.range.created_date &&
                    state.filters.crm_product.range.created_date.map(
                      (date) => new Date(date)
                    ) || ""
                  }
                  block={true}
                />
              </div>
            </div>
            <div className="col-md-3 col-lg-3">
              <div className="input-box">
                <label className="input-label">Application</label>
                <CheckPicker
                  data={state.applicationData}
                  value={
                    state.filters && state.filters.crm_product
                      ? state.filters.crm_product.application_name
                      : []
                  }
                  onChange={(val) =>
                    filterOnchangeData(val, "application_name", "crm_product")
                  }
                  style={{
                    width: "100%",
                    zIndex: 1050,
                  }}
                  block={true}
                  placeholder="Select Application"
                  onOpen={() => getApplication("applicationData")}
                  loading={
                    state.isLoading &&
                    state.isLoading.applicationData &&
                    state.isLoading.applicationData
                  }
                />
              </div>
            </div>
            <div className="col-md-3 col-lg-3">
              <div className="input-box">
                <label className="input-label">Source</label>
                <CheckPicker
                  data={state.sourceData}
                  value={
                    state.filters && state.filters && state.filters.crm_user
                    ? state.filters.crm_user.source
                      : []
                  }
                  onChange={(val) =>
                    filterOnchangeData(val, "source", "crm_user")
                  }
                  style={{
                    width: "100%",
                    zIndex: 1050,
                  }}
                  block={true}
                  placeholder="Select Source"
                  onOpen={() => getSource("sourceData")}
                  loading={
                    state.isLoading &&
                    state.isLoading.sourceData &&
                    state.isLoading.sourceData
                  }
                />
              </div>
            </div>

            <div className="col-md-3 col-lg-3">
              <div className="input-box">
                <label className="input-label">Country</label>
                <CheckPicker
                  data={state.countriesData}
                  value={
                    state.filters && state.filters && state.filters.crm_user
                    ? state.filters.crm_user.country_code
                      : []
                  }
                  onChange={(val) =>
                    filterOnchangeData(val, "country_code", "crm_user")
                  }
                  style={{
                    width: "100%",
                    zIndex: 1050,
                  }}
                  block={true}
                  placeholder="Select Country"
                  onOpen={() => getCountries("countryCode")}
                  loading={
                    state.isLoading &&
                    state.isLoading.countryCode &&
                    state.isLoading.countryCode
                  }
                />
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-3 col-lg-3">
              <div className="input-box">
                <label className="input-label">Account Manager</label>
                <CheckPicker
                  data={state.accountManagerData}
                  value={
                    state.filters && state.filters.crm_user
                      ? state.filters.crm_user.account_manager
                      : []
                  }
                  onChange={(val) =>
                    filterOnchangeData(val, "account_manager", "crm_user")
                  }
                  style={{ width: "100%", zIndex: 1050 }}
                  block={true}
                  placeholder="Select Account Manager"
                  renderMenuItem={(label, item) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Avatar
                        src={item.imgUrl}
                        size="xs"
                        circle
                        style={{ marginRight: 10 }}
                      />
                      {label}
                    </div>
                  )}
                  // renderValue={(value, items) => (
                  // 	<div
                  // 		style={{
                  // 			display: "flex",
                  // 			alignItems: "center",
                  // 			flexWrap: "wrap",
                  // 		}}
                  // 	>
                  // 		{items.map((item) => (
                  // 			<div
                  // 				key={item.value}
                  // 				style={{
                  // 					display: "flex",
                  // 					alignItems: "center",
                  // 					marginRight: 10,
                  // 				}}
                  // 			>
                  // 				<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 5 }} />
                  // 				<span>{item.label}</span>
                  // 			</div>
                  // 		))}
                  // 	</div>
                  // )}
                  renderValue={(value, items) => (
                    <TagPickerImageValueRenderer items={items} />
                  )}
                  // onOpen={() => getAccountManager("accountManager")}
                  loading={
                    state.isLoading &&
                    state.isLoading.accountManager &&
                    state.isLoading.accountManager
                  }
                />
              </div>
            </div>
            <div className="col-md-3 col-lg-3">
              <div className="input-box">
                <label className="input-label">Sales Manager</label>
                <CheckPicker
                  data={state.salesManagerData}
                  value={
                    state.filters && state.filters.crm_user
                      ? state.filters.crm_user.sales_manager
                      : []
                  }
                  onChange={(val) =>
                    filterOnchangeData(val, "sales_manager", "crm_user")
                  }
                  // onChange={crmUserHandler("sales_manager")}
                  style={{ width: "100%", zIndex: 1050 }}
                  block={true}
                  placeholder="Select Sales Manager"
                  renderMenuItem={(label, item) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Avatar
                        src={item.imgUrl}
                        size="xs"
                        circle
                        style={{ marginRight: 10 }}
                      />
                      {label}
                    </div>
                  )}
                  renderValue={(value, items) => (
                    <TagPickerImageValueRenderer items={items} />
                  )}
                  // onOpen={() => getSalesManager("salesManager")}
                  loading={
                    state.isLoading &&
                    state.isLoading.salesManager &&
                    state.isLoading.salesManager
                  }
                />
              </div>
            </div>
            <div className="col-md-3 col-lg-3">
              <div className="input-box">
                <label className="input-label">TSE Owner</label>
                <CheckPicker
                  data={state.tseOwnerData}
                  value={
                    state.filters && state.filters.crm_user
                      ? state.filters.crm_user.tse_owner
                      : []
                  }
                  onChange={(val) =>
                    filterOnchangeData(val, "tse_owner", "crm_user")
                  }
                  // onChange={crmUserHandler("tse_owner")}
                  style={{ width: "100%", zIndex: 1050 }}
                  block={true}
                  placeholder="Select TSE Owner"
                  renderMenuItem={(label, item) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Avatar
                        src={item.imgUrl}
                        size="xs"
                        circle
                        style={{ marginRight: 10 }}
                      />
                      {label}
                    </div>
                  )}
                  // renderValue={(value, items) => (
                  // 	<div
                  // 		style={{
                  // 			display: "flex",
                  // 			alignItems: "center",
                  // 			flexWrap: "wrap",
                  // 		}}
                  // 	>
                  // 		{items.map((item) => (
                  // 			<div
                  // 				key={item.value}
                  // 				style={{
                  // 					display: "flex",
                  // 					alignItems: "center",
                  // 					marginRight: 10,
                  // 				}}
                  // 			>
                  // 				<Avatar src={item.imgUrl} size="xs" circle style={{ marginRight: 5 }} />
                  // 				<span>{item.label}</span>
                  // 			</div>
                  // 		))}
                  // 	</div>
                  // )}
                  renderValue={(value, items) => (
                    <TagPickerImageValueRenderer items={items} />
                  )}
                  // onOpen={() => getTseOwnerManager("tseOwner")}
                  loading={
                    state.isLoading &&
                    state.isLoading.tseOwner &&
                    state.isLoading.tseOwner
                  }
                />
              </div>
            </div>

            <div className="col-md-3 col-lg-3">
              <div className="input-box">
                <label className="input-label">Cancelation Reason</label>
                <CheckPicker
                  data={state.cancelReasonData}
                  value={
                    state.filters && state.filters && state.filters.crm_product
                      ? state.filters.crm_product.cancellation_reason
                      : []
                  }
                  onChange={(val) =>
                    filterOnchangeData(
                      val,
                      "cancellation_reason",
                      "crm_product"
                    )
                  }
                  style={{
                    width: "100%",
                    zIndex: 1050,
                  }}
                  block={true}
                  placeholder="Select Cancelation Reason"
                  onOpen={() => getCancelReason("cancelReason")}
                  loading={
                    state.isLoading &&
                    state.isLoading.cancelReason &&
                    state.isLoading.cancelReason
                  }
                  renderValue={(value, items) => (
                    <TagPickerValueRenderer items={items} />
                  )}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="mx-auto">
              <a
                href="#"
                className={`float-right  ${
                  state.moreButton ? "show" : "d-none"
                }`}
                onClick={handleMoreFilter}
                style={{ padding: "1rem .5rem", color: "#1675e0" }}
              >
                Advance Filter
              </a>
            </div>

            {/* <div className={`col-md-3 col-lg-3 ${moreButton ? "show" : "d-none"}`}>
                              <div className="input-box">
                                  <label className="input-label">&nbsp;</label>
                                  <div className="more-btn btn-blue" onClick={handleMoreFilter} style={{ marginTop: "0px" }}>
                                      More Filter
                                  </div>
                              </div>
                          </div> */}
          </div>

          {/* <div className={`row ${moreFilter ? "show" : "d-none"}`}> */}
          {/* <div className={`row ${moreFilter ? "show" : "d-none"}`}> */}
          {/* <div className={`row ${moreFilter ? "show" : "d-none"}`}> */}
          <div className={`row ${state.advanceFilter ? "show" : "d-none"}`}>
            <div className="col-md-3 col-lg-3">
              <div className="input-box tag-box">
                <label className="input-label">Column Name</label>
                <div className="w-100">
                  <div className="text_filter dropdown bootstrap-select show-tick productselect bs3">
                    <SelectPicker
                      data={state.columnsData}
                      val={state.columnsValueSearch.key}
                      select={true}
                      style={{ width: "100%", zIndex: 1100 }}
                      block={true}
                      onChange={(evt) => searchColumnHandler(evt)}
                      field_name="department_name"
                      onOpen={() => getTattleColumnSearch()}
                      // loading={isColumnLoading}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-lg-3">
              <div className="input-box tag-box">
                <label className="input-label">Value</label>
                <div className="w-100">
                  <div
                    className={`text_filter dropdown bootstrap-select show-tick productselect bs3 search_value_search ${
                      !state.isDateFilter ? "show" : "d-none"
                    }`}
                  >
                    <div className="remove-search">
                    {state.columnsValueSearch.value ? (
                        <BiX
                          style={{ fontSize: "20px" }}
                          onClick={resetSearchFilter}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <input
                      type="text"
                      name="filter_value"
                      onChange={searchValueHandler}
                      placeholder="Search by value"
                      id=""
                      value={state.columnsValueSearch.value}
                      className="form-control show-more-filter-text"
                      autoComplete="off"
                    />
                  </div>
                  <div
                    className={`text_filter dropdown bootstrap-select show-tick productselect bs3 search_value_search ${
                      state.isDateFilter ? "show" : "d-none"
                    }`}
                  >
                    <DateRangePicker
                      showOneCalendar
                      ranges={predefinedRanges}
                      // onOk={handleApplyTimeSearch}
                      // onClean={handleCleanDateSearch}
                      onChange={handleChangeDateSearch}
                      // value={filterTempDateValue || null}
                      block={true}
                    />

                    {/* <DatePicker
                                              name="filter_value"
                                              value={filterTempValue || ""}
                                              onChange={searchDateValueHandler}
                                              className="form-control1"
                                              block={true}
                                          /> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-lg-3 ">
              <label htmlFor="">&nbsp;&nbsp;</label>
              <div className="more_filter-ui-less">
                {/* <div
                  class="more-btn btn-blue more_filter-ui-search"
                  onClick={submitSetSearch}
                >
                  Submit
                </div> */}
                <div
                  className="more_filter-ui-less"
                  style={{ marginTop: "10px" }}
                >
                  <a
                    href="#"
                    onClick={handleLessFilter}
                    style={{ padding: "1rem .5rem", color: "#1675e0" }}
                  >
                    Less Filter
                  </a>

                  {/* <div className="more-btn btn-blue more_filter-ui-search" onClick={handleLessFilter}>
                                          Less Filter
                                      </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListingTopFilter;



// WEBPACK FOOTER //
// ./src/components/childcomponents/ListingTopFilter.js